import React from "react";
import imageUrl from "utils/imageUrl";
import { Link } from "react-router-dom";
function AllCollectionCard({ data }) {
  const linkFunc = function () {
    let link = data.btn_link;
    if (link === "/rent-prop-details") {
      return "/rent-prop-details";
    } else if (link === "/sell-prop-details") {
      return "/sell-prop-details";
    } else if (link === "/booked-prop-details") {
      return "/booked-prop-details";
    } else {
      return "/buy-prop-details";
    }
  };
  console.log(linkFunc);
  return (
    <div class="col-lg-6 col-xl-4">
      <div class="property__grid__single_rentcard collection-card">
        <div class="img__effect">
          <Link
            // to={`${
            //   data.btn_link === "/rent-prop-details"
            //     ? "/rent-prop-details"
            //     : data.btn_link === "/sell-prop-details"
            //     ? "/sell-prop-details"
            //     : "/buy-prop-details"
            //   }`}
            to={linkFunc()}
          >
            <img src={imageUrl(data.img)} alt="Property" />
          </Link>
        </div>
        <div class="property__grid__single_rentcard__inner">
          {data.btn_link === "/sell-prop-details" ? (
            <h5 className="mb-3">{data.project_name}</h5>
          ) : null}

          <h6>
            Size : <span class="sub__info"> 400 sqft</span>
          </h6>
          <h6>
            Unit Number : <span class="sub__info"> 301</span>
          </h6>

          <div className="countdown__wrapper d-flex align-items-center w-100">
            <p className="secondary">
              {data.bed} <i class="fa-solid fa-bed mx-1"></i>
            </p>
            <p className="secondary mx-3">
              {data.bath}
              <i class="fa-solid fa-bath mx-1"></i>
            </p>
          </div>
          {data.btn_link === "/rent-prop-details" ? (
            <div className="countdown__wrapper my-2">
              <p className="secondary">
                <i className="fa-solid fa-clock"></i> Left to Rent
              </p>
              <div className="countdown">
                <h5>
                  <span className="days">12</span>
                  <span className="ref">d</span>
                  <span className="seperator">:</span>
                </h5>
                <h5>
                  <span className="hours"> 22</span>
                  <span className="ref">h</span>
                  <span className="seperator">:</span>
                </h5>
                <h5>
                  <span className="minutes">01</span>
                  <span className="ref">m</span>
                  <span className="seperator"></span>
                </h5>
              </div>
            </div>
          ) : null}

          {data.btn_link === "/sell-prop-details" ? null : (
            <div className="item__info">
              <div className="item__info__single">
                <p>
                  Price: {data.price} Eth{" "}
                  {data.btn_link === "/rent-prop-details" ? "/ mo" : null}
                </p>
              </div>
              <div className="item__info__single">
                <p>RM{data.priceInRM}</p>
              </div>
            </div>
          )}
          {data.btn !== undefined ? (
            <div className="invest__cta__wrapper">
              <div className="invest__cta">
                <Link
                  to={data.btn_link !== undefined ? data.btn_link : "#"}
                  className="button button--effect- disabled"
                  disabled
                >
                  {data.btn}
                </Link>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default AllCollectionCard;
